<!-- eslint-disable vue/attribute-hyphenation -->

<template>
  <div>
    <b-card
      class="profile-header mb-1"
      alt="cover photo"
      body-class="p-0"
    >
      <b-card-header>
        <b-col
          lg="8"
        >
          <h2 class="mb-0">
            {{ name }}

            <feather-icon
              v-if="edit"
              class="cursor-pointer"
              icon="EditIcon"
              @click="editDashboardName()"
            />

          </h2>

        </b-col>
        <b-col>
          <div
            v-if="!edit"
            class="text-right"
          >
            <b-button
              variant="outline-primary"
              @click="editDashboard()"
            >
              Edit
            </b-button>
          </div>
          <div
            v-if="edit"
            class="d-flex justify-content-between"
          >
            <b-button
              variant="success"
              @click="updateDashboard()"
            >
              Save
            </b-button>
            <b-button
              variant="outline-primary"
              @click="addPanelWizard()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              <span class="align-middle">Add Panel</span>
            </b-button>
            <b-button
              variant="outline-danger"
              @click="cancelEdit()"
            >
              <feather-icon
                icon="XIcon"
                class="mr-50"
              />
              <span class="align-middle">Cancel</span>
            </b-button>
          </div>
        </b-col>
      </b-card-header>
    </b-card>

    <grid-layout
      :layout.sync="layout"
      :col-num="colNum"
      :row-height="10"
      :responsive="true"
      :is-draggable="edit"
      :is-resizable="edit"
      :use-css-transforms="true"
      :vertical-compact="true"
    >
      <grid-item
        v-for="item in layout"
        :key="item.i"
        :static="item.static"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
        :min-w="2"
        :min-h="15"
      >
        <!---
        <feather-icon
          v-if="edit"
          icon="DeleteIcon"
          class="mt-1 text-danger cursor-pointer"
          variant="danger"
          @click="removeItem(item.i)"
        />
-->
        <b-card
          :elevation="0"
          no-body
          style="height: 100%; width: 100%; padding: 0;"
        >
          <component
            :is="item.panelconfig.panel"
            v-if="item.panelconfig.panel !== undefined"
            v-bind="{ panelconfig: item.panelconfig, edit: edit, item: item }"
            @removeItem="removeItem(item.id)"
            @editPanel="editPanel(item)"
          />

        </b-card>
      </grid-item>
    </grid-layout>

    <!--- !Vue Grid layout -->

    <b-modal
      ref="my-modal"
      size="xl"
      hide-footer
      no-close-on-backdrop
      title="Add Panel"
    >
      <add-panel-wizard
        @addPanel="createPanel"
      />
    </b-modal>

    <b-modal
      ref="edit-dashboard-name"
      size="md"
      hide-footer
      title="Edit Dashboard Name"
    >
      <b-form-input
        v-model="name"
        placeholder="Enter Dashboard Name"
      />
      <b-button
        variant="success"
        @click="updateDashboardName()"
      >
        Save
      </b-button>
    </b-modal>

    <b-modal
      ref="edit-panel"
      size="xl"
      no-close-on-backdrop
      title="Edit Panel"
      ok-title="Save"
      cancel-variant="outline-primary"
      cancel-title="Cancel"
      @ok="updatePanel"
      @cancel="cancelEditPanel"
    >
      <edit-panel
        :panelconfig="panelconfig"
      />
    </b-modal>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
// uuid
import { v4 as uuidv4 } from 'uuid'
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BButton,
  BModal,
  BFormInput,

} from 'bootstrap-vue'
import { Dashboard, DashLayout, DashItem } from 'vue-responsive-dash'
import { GridLayout, GridItem } from 'vue-grid-layout'

// Panels

// Statistics
import StatisticCardVertical from './Panels/Statistics/StatisticCardVertical/StatisticCardVertical.vue'
import StatisticCardWithAreaChart from './Panels/Statistics/StatisticCardWithAreaChart/StatisticCardWithAreaChart.vue'

// Analytics
import Chart from './Panels/Analytics/LineChart/LineChart.vue'
import BarChart from './Panels/Analytics/BarChart/BarChart.vue'

import * as mutations from '../../../graphql/mutations'
import * as queries from '../../../graphql/queries'

import AddPanelWizard from './AddPanelWizard/AddPanelWizard.vue'
import EditPanel from './EditPanel/EditPanel.vue'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'

// Data Display
import Table from './Panels/DataDisplay/Table.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    Dashboard,
    DashLayout,
    DashItem,
    GridLayout,
    GridItem,
    BButton,
    BModal,
    BFormInput,
    AddPanelWizard,
    EditPanel,

    // Statistics
    StatisticCardVertical,
    StatisticCardWithAreaChart,

    // Analytics
    Chart,
    BarChart,

    // Data Display
    Table,

    BCardActions,
  },
  data() {
    return {
      id: this.$route.params.id,
      originalLayout: [],
      name: '',
      edit: false,
      editButton: {
        title: 'Edit',
        variant: 'outline-primary',
      },
      dlayouts: [],
      layout: [],
      draggable: true,
      resizable: true,
      colNum: 12,
      index: 0,
      panelconfig: {},
      EditPanelConfig: {},
    }
  },
  async created() {
    await this.getDashboard()
    this.index = this.layout.length
  },
  methods: {
    async getDashboard() {
      const dashboardRespose = await API.graphql({
        query: queries.getDashboard,
        variables: {
          id: this.$route.params.id,
        },
      })
      const dashboard = dashboardRespose.data.getDashboard
      this.name = dashboard.name
      // check if layout is null
      if (dashboard.layout !== null) {
        this.layout = JSON.parse(dashboard.layout)
        this.index = this.layout.length
      } else {
        this.layout = []
      }
    },
    addPanelWizard() {
      this.$refs['my-modal'].show()
    },
    createPanel(panelconfig) {
      // eslint-disable-next-line no-plusplus
      this.index++
      this.layout.push({
        x: (this.layout.length * 2) % (this.colNum || 12),
        y: this.layout.length + (this.colNum || 12), // puts it at the bottom
        w: 2,
        h: 15,
        i: this.index, // eslint-disable-line no-plusplus
        panelconfig,
        id: uuidv4(),
      })

      this.$refs['my-modal'].hide()
    },
    removeItem(val) {
      // find id of item to remove from layout and originalLayout
      const layoutIndex = this.layout.findIndex(item => item.id === val)
      this.layout.splice(layoutIndex, 1)
    },
    editDashboard() {
      this.edit = true
      this.editButton.title = 'Cancel'
      this.editButton.variant = 'outline-danger'
      this.originalLayout = JSON.parse(JSON.stringify(this.layout))
    },
    cancelEdit() {
      this.edit = false
      this.editButton.title = 'Edit'
      this.editButton.variant = 'outline-primary'
      this.layout = this.originalLayout
    },
    editDashboardName() {
      this.$refs['edit-dashboard-name'].show()
    },
    async updateDashboard() {
      const layout = JSON.stringify(this.layout)
      const dashboard = {
        id: this.$route.params.id,
        layout,
      }
      await API.graphql({
        query: mutations.updateDashboard,
        variables: {
          input: dashboard,
        },
      // eslint-disable-next-line no-unused-vars
      }).then(res => {
        this.edit = false
      })
    },
    async updateDashboardName() {
      const dashboard = {
        id: this.$route.params.id,
        name: this.name,
      }
      await API.graphql({
        query: mutations.updateDashboard,
        variables: {
          input: dashboard,
        },
      // eslint-disable-next-line no-unused-vars
      }).then(res => {
        this.$refs['edit-dashboard-name'].hide()
      })
    },
    editPanel(panel) {
      this.panelconfig = panel.panelconfig
      this.editPanelConfig = panel
      this.$refs['edit-panel'].show()
    },
    updatePanel(panel) {
      this.panelconfig = panel
      this.$refs['edit-panel'].hide()
    },
    cancelEditPanel() {
      this.panelconfig = this.editPanelConfig
      this.$refs['edit-panel'].hide()
    },
  },
}

</script>

<style>
.box {
  height: 100%;
  width: 100%;
  border: 2px solid #42b983;
  border-radius: 5px;
}
</style>
